import {
	CONNECT_MCP_DESCRIPTION,
	ConnectMcpContent,
	MCP_DOCS_ARTICLE_ID,
} from "@productlane/ui/src/components/connect-mcp-content"

import { MetaInfo } from "@/components/meta-info"
import { SettingsHeader } from "../settings-header"

export function McpSettingsPage() {
	return (
		<>
			<MetaInfo title="MCP Settings" />

			<SettingsHeader
				className="mb-7"
				title="MCP"
				subtitle={CONNECT_MCP_DESCRIPTION}
				subtitleClassName="max-w-md"
				docsArticle={MCP_DOCS_ARTICLE_ID}
			/>

			<ConnectMcpContent variant="page" />
		</>
	)
}
